<template>
  <nav class="fixed bottom-0 w-full max-w-[800px] z-50 bg-white/90 backdrop-blur-xl rounded-t-[32px] border-t border-gray-100 shadow-[0_-15px_30px_rgba(0,0,0,0.06)] pb-safe">
    <div class="relative pt-2 pb-1">
      <ul class="grid grid-flow-col grid-cols-5 justify-between">
        <NavLink v-for="(nav, index) in navbar" 
          :key="index" 
          :to="{ name: nav.name }" 
          :icon="nav.icon" 
          :label="nav.label" 
          :custom-class="nav.customClass" 
          :notif="nav.notif"
          :newTab="nav.newTab"
        />
      </ul>
      <div 
        v-if="currentIndex !== null && currentIndex >= 0"
        class="h-1 bg-primary rounded-b-full w-[20%] absolute top-0 ease-in-out transition-all duration-500"
        :class="animatedClass" 
        :style="{ left: `calc(${currentIndex} * 20%)` }"
      ></div>
    </div>
  </nav>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, onMounted, watch, computed } from 'vue';
import NavLink from './NavLink.vue';

export default {
  name: 'NavBar',
  components: { NavLink },
  setup() {
    const currentIndex = ref(null);
    const animatedClass = ref('');
    const route = useRoute();

    // Daftar menu navigasi dengan nilai notif dipastikan sebagai angka
    const navbar = computed(() => [
      { name: 'Home', icon: ['fas', 'house'], label: 'Home', notif: 0, newTab: false },
      { name: 'Publication', icon: ['fas', 'newspaper'], label: 'News', notif: 0, newTab: false },
      { name: 'QRCodeScanner', icon: ['fas', 'qrcode'], label: 'Pay', customClass: 'QR', notif: 0, newTab: false },
      { name: 'Academic', icon: ['fas', 'graduation-cap'], label: 'Edu', notif: 0, newTab: false },
      { name: 'Profile', icon: ['fas', 'user'], label: 'Profile', notif: 0, newTab: false},
    ]);

    // Cek indeks halaman aktif di navbar
    const checkIndex = () => {
      currentIndex.value = navbar.value.findIndex(item => item.name === route.name);
      animatedClass.value = 'animate-wideAbit';

      setTimeout(() => {
        animatedClass.value = '';
      }, 500);
    };

    onMounted(() => {
      checkIndex();
    });

    // Pantau perubahan route
    watch(() => route.name, checkIndex);

    return {
      navbar,
      currentIndex,
      animatedClass,
    };
  },
};
</script>
